import { Descriptions } from 'element-ui'

/** 文件说明
@Author: dalang
@LastModifyTime: 2022-05-08  17:41:46
@Desc: 万知商务-公共模块路由表
**/
const BusinessIndex = () => import('@/components/business/BusinessIndex')
const BusinessPage = () => import('@/components/business/pages/frontedPage/BusinessPage')
const BusinesserSettle = () => import('@/components/business/pages/BusinesserSettleIn/Index')
const BusinessEvaluation = () => import('@/components/business/pages/businessEvaluation/Index')
const BusinessRequireInfo = () => import('@/components/business/pages/BusinessInformation/Index')
const ShoppingCart = () => import('@/components/business/pages/shoppingCartModule')
const SnapUp = () => import('@/components/business/pages/snapUp/Order')

export default {
  path: '/wzmall',
  name: 'Wzmall',
  component: BusinessIndex,
  redirect: '/wzmall/businessRequireInfo',
  meta: {
    title: '万知商务 - 家产物件 衣饰用品 农村菜园 粮油吃喝 金子店名 场外玩具 机器材料  智装工厂 信息和需求 - 万知',
    Description:'万知商务，是 万知 网上平台中的一个商务板块。可以通过  万知商务.com 这个中文网址访问到网上站点。这里把商务在网上交易，进行了形式上的划分，家产物件 衣饰用品 农村菜园 粮油吃喝 金子店名 场外玩具 机器材料  智装工厂 ，在万知商务注册、登录后，可以在这里发起并组建商务网点，可以是商品销售的形式，也可以是产品宣传的形式。',
    keywords:'商品信息，需求，商务',
    requireLogin: false
  },
  children: [
    {
      path: '/wzmall/businessRequireInfo',
      name: 'BusinessRequireInfo',
      component: BusinessRequireInfo,
      meta: {
        title: '万知商务 - 家产物件 衣饰用品 农村菜园 粮油吃喝 金子店名 场外玩具 机器材料  智装工厂 信息和需求 - 万知',
        Description:'万知商务，是 万知 网上平台中的一个商务板块。可以通过  万知商务.com 这个中文网址访问到网上站点。这里把商务在网上交易，进行了形式上的划分，家产物件 衣饰用品 农村菜园 粮油吃喝 金子店名 场外玩具 机器材料  智装工厂 ，在万知商务注册、登录后，可以在这里发起并组建商务网点，可以是商品销售的形式，也可以是产品宣传的形式。',
        keywords:'商品信息，需求，商务',
      }
    },
    {
      path: '/wzmall/index',
      name: 'WzmallIndex',
      component: BusinessPage,
      meta: {
        title: '商家详情 - 万知商务 - 万知',
        Description:'展示商家详细信息包括公司简介商品店铺信息',
        keywords:'公司简介，店铺'
      }
    },
    {
      path: '/wzmall/businessEvaluation',
      name: 'BusinessEvaluation',
      component: BusinessEvaluation,
      meta: {
        title: '商品详情 - 万知商务 - 万知',
        Description:'展示商品详细信息包括图文文字展示',
        keywords:'商品详情'
      }
    },
    {
      path: '/wzmall/businsserSettleIn',
      name: 'BusinsserSettleIn',
      component: BusinesserSettle,
      meta: {
        title: '商务入驻 - 万知商务 - 万知',
        Description:'展示需要申请商务入驻所需填写资料',
        keywords:'商务 入驻'
      }
    },
    {
      path: '/wzmall/shoppingCart',
      name: 'ShoppingCart',
      component: ShoppingCart,
      meta: {
        title: '购物车 - 万知商务 - 万知',
        Description:'展示购物车已经添加的全部商品',
        keywords:'商品，购物车',
        requireLogin: true
      }
    },
    {
      path: '/wzmall/snapUp',
      name: 'SnapUp',
      component: SnapUp,
      meta: {
        title: '商品抢购 - 万知商务 - 万知',
        Description:'展示通过活动抢购的全部商品',
        keywords:'商品抢购',
        requireLogin: true
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/business.js